import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useSelector } from 'react-redux';

// import consts
import { ALL_URLS, PAGES, PAGE_IDS } from 'js/constants/Pages';

// import pages
import PageHome from 'js/page/Page.home';
import PageCharacters from 'js/page/Page.characters';
import PageTermsOfUse from 'js/page/Page.terms_of_use';
import PageCookiePolicy from 'js/page/Page.cookie_policy';
import PagePrivacyPolicy from 'js/page/Page.privacy_policy';
import PageArticle from 'js/page/Page.article';
import PageIndividualCharacter from 'js/page/Page.individual_character';
import PageLocations from 'js/page/Page.locations';
import PageIndividualLocation from 'js/page/Page.individual_location';
import PageAbout from 'js/page/Page.about';
import PageMake from 'js/page/Page.make';
import PageWatch from 'js/page/Page.watch';
import PageTemplate from 'js/page/Page.template';
import PageGallery from 'js/page/Page.gallery';
import PageGames from 'js/page/Page.games';
import PageIndividualGame from 'js/page/Page.individual_game';

import PageNotFound from 'js/page/Page.not_found';
import SectionMain from 'js/containers/section/Section.main';

const Router = () => {
  const location = useLocation();
  const links = useSelector((state) => state.app.navigation || []);
  const pageTemplateUrls = useSelector((state) => state.pageTemplates.allUrls || []);

  console.log('links', links);

  const activeInternalPages = useMemo(() => {
    const pages = new Set();

    links.forEach((link) => {
      if (link.link_type === 'internal_page') {
        pages.add(link.page);
      }

      link.children?.forEach((childLink) => {
        if (childLink.link_type === 'internal_page') {
          pages.add(childLink.page);
        }
      });
    });

    return pages;
  }, [links]);

  const activeMakeLink = activeInternalPages.has('activities');
  const activeVideoLink = activeInternalPages.has(PAGES.watch.id);
  const activeGalleryLink = activeInternalPages.has('gallery');

  useEffect(() => {
    //
    if (location.hash && location.hash !== '') {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        window.scrollTo(0, element.getBoundingClientRect().top + window.scrollY);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait" initial={false}>
      <SectionMain location={location} key={location.pathname}>
        <Routes location={location} key={location.pathname}>
          <Route path={ALL_URLS[PAGE_IDS.home]} element={<PageHome path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.terms]} element={<PageTermsOfUse path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.privacy_policy]} element={<PagePrivacyPolicy path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.cookie_policy]} element={<PageCookiePolicy path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.vision_and_values]} element={<PageArticle path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.about]} element={<PageAbout path={location.pathname} />} />
          <Route path={ALL_URLS[PAGE_IDS.characters]} element={<PageCharacters path={location.pathname} />} />
          {activeGalleryLink && (
            <Route path={ALL_URLS[PAGE_IDS.gallery]} element={<PageGallery path={location.pathname} />} />
          )}
          <Route path={ALL_URLS[PAGE_IDS.games]} element={<PageGames path={location.pathname} />} />
          <Route path={`${ALL_URLS[PAGE_IDS.games]}/:game`} element={<PageIndividualGame path={location.pathname} />} />

          {activeMakeLink && <Route path={ALL_URLS[PAGE_IDS.make]} element={<PageMake path={location.pathname} />} />}
          {activeVideoLink && (
            <Route path={ALL_URLS[PAGE_IDS.watch]} element={<PageWatch path={location.pathname} />} />
          )}
          <Route
            path={`${ALL_URLS[PAGE_IDS.characters]}/:id`}
            element={<PageIndividualCharacter path={location.pathname} />}
          />
          <Route path={ALL_URLS[PAGE_IDS.explore_porthole]} element={<PageLocations path={location.pathname} />} />
          <Route
            path={`${ALL_URLS[PAGE_IDS.explore_porthole]}/:id`}
            element={<PageIndividualLocation path={location.pathname} />}
          />
          {pageTemplateUrls.map((url) => (
            <Route key={url} path={url} element={<PageTemplate path={location.pathname} url={url} />} />
          ))}
          <Route path="404" element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </SectionMain>
    </AnimatePresence>
  );
};

export default Router;
